import useTranslation from '@/hooks/useTranslation';
import { Text, Box, Stack, rem } from '@mantine/core';
import { IconSun, IconPhone, IconMapPin, IconAt } from '@tabler/icons';
import classes from '../styles/Contact.module.css';


function ContactIcon({icon: Icon, title, description, ...others }) {

  return (
    <div className={classes.wrapper} {...others}>
      <Box mr="md">
        <Icon style={{ width: rem(24), height: rem(24) }} />
      </Box>

      <div>
        <Text size="xs" className={classes.title}>
          {title}
        </Text>
        <Text className={classes.description}>{description}</Text>
      </div>
    </div>
  );
}



export function ContactIconsList() {
  const { t } = useTranslation();

  const Email = t("ContactSection")[1].Email;
  const Phone = t("ContactSection")[2].Phone;
  const Address = t("ContactSection")[3].Address;
  const WorkingHours = t("ContactSection")[4].WorkingHours;
  const MOCKDATA = [
    { title: Email, description: 'em2993@support.quicktor.co.il', icon: IconAt },
    { title: Phone, description: '055-7259188', icon: IconPhone },
    // { title: Address, description: '844 Morris Park avenue', icon: IconMapPin },
    // { title: WorkingHours, description: '8 a.m. – 11 p.m.', icon: IconSun },
  ];
  const items = MOCKDATA.map((item, index) => <ContactIcon key={index} {...item} />);
  return <Stack>{items}</Stack>;
}